 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780785223122_COVER from '@/components/text/9780785223122_Cover'
 import TEXT9780785223122_ACCLAIM_FOR_KELLY_IRVIN from '@/components/text/9780785223122_Acclaim_For_Kelly_Irvin'
 import LOVE_1 from '@/components/love_1'
 import TEXT9780785223122_TITLE_PAGE from '@/components/text/9780785223122_Title_Page'
 import TEXT9780785223122_COPYRIGHT from '@/components/text/9780785223122_Copyright'
 import TEXT9780785223122_DEDICATION from '@/components/text/9780785223122_Dedication'
 import TEXT9780785223122_FRONTMATTER_1 from '@/components/text/9780785223122_Frontmatter_1'
 import TEXTNAV from '@/components/text/nav'
 import TEXT9780785223122_CHAPTER_1 from '@/components/text/9780785223122_Chapter_1'
 import TEXT9780785223122_CHAPTER_2 from '@/components/text/9780785223122_Chapter_2'
 import TEXT9780785223122_CHAPTER_3 from '@/components/text/9780785223122_Chapter_3'
 import TEXT9780785223122_CHAPTER_4 from '@/components/text/9780785223122_Chapter_4'
 import TEXT9780785223122_CHAPTER_5 from '@/components/text/9780785223122_Chapter_5'
 import TEXT9780785223122_CHAPTER_6 from '@/components/text/9780785223122_Chapter_6'
 import TEXT9780785223122_CHAPTER_7 from '@/components/text/9780785223122_Chapter_7'
 import TEXT9780785223122_CHAPTER_8 from '@/components/text/9780785223122_Chapter_8'
 import TEXT9780785223122_CHAPTER_9 from '@/components/text/9780785223122_Chapter_9'
 import TEXT9780785223122_CHAPTER_10 from '@/components/text/9780785223122_Chapter_10'
 import TEXT9780785223122_CHAPTER_11 from '@/components/text/9780785223122_Chapter_11'
 import TEXT9780785223122_CHAPTER_12 from '@/components/text/9780785223122_Chapter_12'
 import TEXT9780785223122_CHAPTER_13 from '@/components/text/9780785223122_Chapter_13'
 import TEXT9780785223122_CHAPTER_14 from '@/components/text/9780785223122_Chapter_14'
 import TEXT9780785223122_CHAPTER_15 from '@/components/text/9780785223122_Chapter_15'
 import TEXT9780785223122_CHAPTER_16 from '@/components/text/9780785223122_Chapter_16'
 import TEXT9780785223122_CHAPTER_17 from '@/components/text/9780785223122_Chapter_17'
 import TEXT9780785223122_CHAPTER_18 from '@/components/text/9780785223122_Chapter_18'
 import TEXT9780785223122_CHAPTER_19 from '@/components/text/9780785223122_Chapter_19'
 import TEXT9780785223122_CHAPTER_20 from '@/components/text/9780785223122_Chapter_20'
 import TEXT9780785223122_CHAPTER_21 from '@/components/text/9780785223122_Chapter_21'
 import TEXT9780785223122_CHAPTER_22 from '@/components/text/9780785223122_Chapter_22'
 import TEXT9780785223122_CHAPTER_23 from '@/components/text/9780785223122_Chapter_23'
 import TEXT9780785223122_CHAPTER_24 from '@/components/text/9780785223122_Chapter_24'
 import TEXT9780785223122_CHAPTER_25 from '@/components/text/9780785223122_Chapter_25'
 import TEXT9780785223122_CHAPTER_26 from '@/components/text/9780785223122_Chapter_26'
 import TEXT9780785223122_CHAPTER_27 from '@/components/text/9780785223122_Chapter_27'
 import TEXT9780785223122_CHAPTER_28 from '@/components/text/9780785223122_Chapter_28'
 import TEXT9780785223122_CHAPTER_29 from '@/components/text/9780785223122_Chapter_29'
 import TEXT9780785223122_CHAPTER_30 from '@/components/text/9780785223122_Chapter_30'
 import TEXT9780785223122_CHAPTER_31 from '@/components/text/9780785223122_Chapter_31'
 import TEXT9780785223122_CHAPTER_32 from '@/components/text/9780785223122_Chapter_32'
 import TEXT9780785223122_CHAPTER_33 from '@/components/text/9780785223122_Chapter_33'
 import TEXT9780785223122_CHAPTER_34 from '@/components/text/9780785223122_Chapter_34'
 import TEXT9780785223122_CHAPTER_35 from '@/components/text/9780785223122_Chapter_35'
 import TEXT9780785223122_CHAPTER_36 from '@/components/text/9780785223122_Chapter_36'
 import TEXT9780785223122_CHAPTER_37 from '@/components/text/9780785223122_Chapter_37'
 import TEXT9780785223122_CHAPTER_38 from '@/components/text/9780785223122_Chapter_38'
 import TEXT9780785223122_CHAPTER_39 from '@/components/text/9780785223122_Chapter_39'
 import LOVE_2 from '@/components/love_2'
 import TEXT9780785223122_A_NOTE_FROM_THE_AUTHOR from '@/components/text/9780785223122_A_Note_From_The_Author'
 import TEXT9780785223122_DISCUSSION_QUESTIONS from '@/components/text/9780785223122_Discussion_Questions'
 import TEXT9780785223122_BACKMATTER_1 from '@/components/text/9780785223122_backmatter_1'
 import TEXT9780785223122_BACKMATTER_2 from '@/components/text/9780785223122_backmatter_2'
 import TEXT9780785223122_ABOUT_THE_AUTHOR from '@/components/text/9780785223122_About_the_Author'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/nav",
 			"name" : "text/nav",
 			"component" : TEXTNAV
 		},
 		{
 			"path" : "/text/9780785223122_Chapter_1",
 			"name" : "text/9780785223122_Chapter_1",
 			"component" : TEXT9780785223122_CHAPTER_1
 		},
 		{
 			"path" : "/text/9780785223122_Chapter_2",
 			"name" : "text/9780785223122_Chapter_2",
 			"component" : TEXT9780785223122_CHAPTER_2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js